<template>
  <div class="content-survey-measures">

    <div class="content-survey-measures__header">
      <h3>{{ title }}</h3>

      <div class="measures-header__controls">
        <select-filter-alt v-model="selectedCategory" :selections="categories" />
      </div>

      <div v-if="currentCommentary" class="measures-header__commentary">
        <p class="text-legend text--darkgrey">
          {{ currentCommentary }}
        </p>
      </div>
    </div>

    <!-- chart here -->
    <div class="content-survey-measures__chart">
      <BarChartY :type.sync="selectedCategory" @data-sanitized="loadData" />
    </div>
  </div>
</template>

<script>
import SelectFilterAlt from '@/components/ui/SelectFilterAlt.vue';

export default {
  name: 'SurveyMeasures',
  components: {
    SelectFilterAlt,
    BarChartY: () => import('@/components/content/chapter2/charts/BarChartY.vue'),
  },
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loadedData: [],
      selectedCategory: '',
    };
  },
  computed: {
    categories() {
      return this.loadedData.map((d) => d.type);
    },
    currentCommentary() {
      const selectedSet = this.loadedData.find((item) => item.type === this.selectedCategory);
      return selectedSet ? selectedSet.commentary : '';
    },
  },
  methods: {
    loadData(data) {
      // get unique objects by "type" prop
      this.loadedData = [...new Map(data.map(({ type, commentary }) => [type, { type, commentary }])).values()];
    },
  },
};
</script>

<style lang="scss" scoped>
.content-survey-measures {
  padding: 60px 0;
  // background-color: #fff;

  @media #{map-get($media-breakpoints, 'mobile')} {
    padding: 30px 0;
  }

  &__header {
    margin-bottom: 30px;

    .measures-header__controls {
      margin-bottom: 20px;
    }

    .measures-header__commentary {
      background-color: #f0f0f0;
      border-radius: 5px;
      padding: 10px;

      p {
        margin-bottom: 0;
      }
    }
  }
}
</style>
